export const navigation = [
  {
    text: 'Home',
    path: '/home',
    icon: 'fas fa-home'
  },
  /*{
    text: 'Settings',
    path: '/profile',
    icon: 'fas fa-cogs'
  },*/
  {
    text: 'Reports',
    icon: 'fas fa-chart-bar',
    items: [
      {
        text: 'Serious Injury Or Fatality',
        icon: 'fas fa-user-injured',
        path: '/sif'
      },
      {
        text: 'Health, Safety & Env.',
        icon: 'fas fa-heartbeat',
        path: '/hse'
      },
      {
        text: 'Env., Social & Governance',
        icon: 'fas fa-leaf',
        path: '/esg'
      },
    ]
  }
  ];

  export const navigationCompanyAdmin = [
    {
      text: 'User Mgmt.',
      path: '/admin-users',
      icon: 'fas fa-users-cog'
    },
  ];

  export const navigationSIFRW = [
    {
      text: 'Company SIF Data',
      icon: 'fas fa-database',
      path: '/sifdata',
    }
  ];

  export const navigationAIUser = [
    {
      text: 'AXPC Assistant',
      path: '/axpc-assistant',
      icon: 'fas fa-robot'
    },
    {
      text: 'AI Knowledge Base',
      path: '/ai-knowledge-base',
      icon: 'fas fa-book'
    }
  ];


  export const navigationAdmin = [
    {
      text: 'User Mgmt.',
      path: '/admin-users',
      icon: 'fas fa-users-cog'
    },
    {
      text: 'Companies Mgmt.',
      path: '/admin-companies',
      icon: 'fas fa-boxes'
    },
  ];

  export const navigationUnauthenticated = [
  ]
